/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeConsent,
    CardTypeConsentFromJSON,
    CardTypeConsentFromJSONTyped,
    CardTypeConsentToJSON,
} from './CardTypeConsent';

/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    id?: string;
    /**
     * 
     * @type {Array<CardTypeConsent>}
     * @memberof Person
     */
    cardTypeConsent?: Array<CardTypeConsent>;
}

export function PersonFromJSON(json: any): Person {
    return PersonFromJSONTyped(json, false);
}

export function PersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Person {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardTypeConsent': !exists(json, 'cardTypeConsent') ? undefined : ((json['cardTypeConsent'] as Array<any>).map(CardTypeConsentFromJSON)),
    };
}

export function PersonToJSON(value?: Person | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardTypeConsent': value.cardTypeConsent === undefined ? undefined : ((value.cardTypeConsent as Array<any>).map(CardTypeConsentToJSON)),
    };
}

